import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE = '/api/audit_logs';

export default {
    getAuditLogs(params) {
        return Api().get(RESOURCE, { params })
            .catch((err) => errorHandler(err, null));
    },
}
